import { FormattedMessage } from '@flipster/i18n';
import UserVipstatusBasicAccountColorIcon from '@flipster/react/icon/generated/UserVipstatusBasicAccountColorIcon';
import UserVipstatusVipAccountColorIcon from '@flipster/react/icon/generated/UserVipstatusVipAccountColorIcon';
import { center, circle, flex } from '@flipster/styled-system/patterns';

interface UserTierAccountIconProps {
  size?: number;
  vipTier?: number;
  profileImageUrl?: string;
  me?: boolean;
}
export const UserTierAccountIcon = ({ size = 32, vipTier = 0, profileImageUrl, me }: UserTierAccountIconProps) => {
  const isVip = vipTier > 0;
  return (
    <div className={flex({ position: 'relative' })}>
      {profileImageUrl ? (
        <img
          src={profileImageUrl}
          alt='Profile picture of this trader'
          className={circle()}
          style={{ width: size, height: size }}
        />
      ) : isVip ? (
        <UserVipstatusVipAccountColorIcon size={size} />
      ) : (
        <UserVipstatusBasicAccountColorIcon size={size} />
      )}
      {me && (
        <div
          className={center({
            position: 'absolute',
            textStyle: 'Text/XXS/Strong',
            px: 4,
            rounded: 999,
            bg: 'background.default.level-3',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'border.default.level-2',
            transform: 'translateX(-50%)',
            left: '50%',
            bottom: 0,
          })}
        >
          <FormattedMessage id='Autogen_common.r251126.s_Me' />
        </div>
      )}
    </div>
  );
};
